import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import globalMU from "globalMU"
declare var window:any

export type DefinirOfertaSeletivaItemParams = {
    identificadorItem: number,
    ofertaSelecionada: boolean
}

export async function definirOfertaSeletivaItem(params: DefinirOfertaSeletivaItemParams) {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirOfertaSeletivaItem(
            params.identificadorItem,
            store.getState().orcamento.IdentificadorOrcamento,
            params.ofertaSelecionada
        )

        const atualizarOrcamentoLegado = () => {
            const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == params.identificadorItem)
    
            const orcamentoLegado = window.orcamentoController.model
            //const itensLegado = orcamentoLegado.get('ItensOrcamento')
            //const itemLegado = itensLegado.models.find(item => item.get('Identificador') == params.identificadorItem)
    
            //itemLegado.atualizar(itemAtualizado,true)
            orcamentoLegado.atualizar(orcamentoAtualizado)
        
        }

        atualizarOrcamentoLegado()

    } finally {
        globalMU.unblockUI()
    }
}